module.exports = __webpack_public_path__ + "media/images/NYCHD-0b1c816ea0c0da6dec5b5c087ffae876.jpg";